import { useEffect, useRef } from "react";
import { TextB, TextItalic, TextStrikethrough, ListBullets, Link, Eraser } from "@phosphor-icons/react";

// Editor ricco leggero (contentEditable): grassetto, corsivo, barrato, elenchi, link.
// Emette HTML; il backend sanitizza con allowlist prima di salvare/pubblicare.
export default function RichTextEditor({ value, onChange, testid, placeholder }) {
  const ref = useRef(null);
  const lastEmitted = useRef(null); // null al mount → l'useEffect idrata il valore iniziale

  useEffect(() => {
    if (ref.current && value !== lastEmitted.current) {
      ref.current.innerHTML = value || "";
      lastEmitted.current = value || "";
    }
  }, [value]);

  const exec = (cmd, arg = null) => {
    ref.current?.focus();
    document.execCommand(cmd, false, arg);
    emit();
  };

  const emit = () => {
    const html = ref.current?.innerHTML || "";
    lastEmitted.current = html;
    onChange(html);
  };

  const addLink = () => {
    const url = window.prompt("Inserisci il link (https://...)");
    if (url && url.startsWith("http")) exec("createLink", url);
  };

  const Btn = ({ cmd, icon: Icon, label, onClick }) => (
    <button type="button" onClick={onClick || (() => exec(cmd))} title={label} data-testid={`${testid}-${cmd || "link"}`}
      className="h-8 w-8 rounded-md flex items-center justify-center text-zinc-600 hover:bg-zinc-200 hover:text-zinc-900 transition">
      <Icon size={15} weight="bold" />
    </button>
  );

  return (
    <div className="border border-zinc-300 rounded-md bg-white overflow-hidden" data-testid={testid}>
      <div className="flex items-center gap-0.5 px-2 py-1.5 border-b border-zinc-200 bg-zinc-50">
        <Btn cmd="bold" icon={TextB} label="Grassetto" />
        <Btn cmd="italic" icon={TextItalic} label="Corsivo" />
        <Btn cmd="strikeThrough" icon={TextStrikethrough} label="Barrato" />
        <Btn cmd="insertUnorderedList" icon={ListBullets} label="Elenco puntato" />
        <Btn icon={Link} label="Inserisci link" onClick={addLink} />
        <Btn cmd="removeFormat" icon={Eraser} label="Rimuovi formattazione" />
      </div>
      <div ref={ref} contentEditable onInput={emit} data-testid={`${testid}-area`}
        data-placeholder={placeholder || "Scrivi qui..."}
        className="min-h-28 px-3 py-2 text-sm text-zinc-800 focus:outline-none [&_ul]:list-disc [&_ul]:pl-5 [&_a]:text-sky-600 [&_a]:underline empty:before:content-[attr(data-placeholder)] empty:before:text-zinc-400" />
    </div>
  );
}
